"use client";

import clsx from "clsx";

type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: "primary" | "secondary" | "outline" | "danger";
  size?: "sm" | "md" | "lg";
};

export default function Button({
  children,
  variant = "primary",
  size = "md",
  className,
  ...props
}: ButtonProps) {
  const baseStyles =
    "font-medium transition-all disabled:opacity-50 disabled:cursor-not-allowed";

  const variantStyles = {
    primary: "bg-012061 text-FFFFFF hover:bg-blue-700 w-40 ",
    secondary: "bg-gray-200 text-000000 hover:bg-gray-300",
    outline: "border-[1px] border-012061 text-012061 text-14-tamil-700 hover:bg-gray-100",
    danger: "bg-red-600 text-FFFFFF hover:bg-red-700",
    darkblue: "bg-2D497E text-FFFFFF text-16-tamil-600",
    yellow: "bg-FFDB59 text-FFFFFF",
  };

  const sizeStyles = {
    sm: "px-3 py-1 text-sm",
    md: "px-4 py-3",
    lg: "px-5 py-3 text-lg",
  };    

  return (
    <button
      {...props}
      className={clsx(
        baseStyles,
        variantStyles[variant],
        sizeStyles[size],
        className
      )}
    >
      {children}
    </button>
  );
}